// The theme context's contract, split out from the provider component for the
// same reason as auth-context.ts: Fast Refresh only preserves state for modules
// that export components exclusively. Provider in ThemeContext.tsx, hook in
// use-theme.ts.
import { createContext } from 'react';

export type ThemePreference = 'light' | 'dark' | 'system';
export type ResolvedTheme = 'light' | 'dark';

export interface ThemeContextValue {
  preference: ThemePreference;
  resolved: ResolvedTheme;
  setPreference: (pref: ThemePreference) => void;
  toggle: () => void;
}

export const ThemeContext = createContext<ThemeContextValue | undefined>(undefined);
